import React from 'react';
import { flex } from '@fabric-ui/theme';
import { Box, useTheme } from '@mui/material';

export function ProjectionIcon({ icon, backgroundColor, color }: { icon: React.ReactNode; backgroundColor: string; color: string }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        ...flex.center,
        svg: {
          backgroundColor,
          color: color ?? theme.palette.white.main,
          padding: '6px',
          borderRadius: '12px',
          border: `1px solid ${color ? theme.palette.colors.neutrals[400] : 'transparent'}`,
          '.MuiInputBase-root.MuiOutlinedInput-root &, &': {
            height: '24px',
            width: '24px',
          },
        },
      }}>
      {icon}
    </Box>
  );
}
